export default __webpack_public_path__ + "static/media/pic10.8c30fb00.png";